import { getCurrentUser } from '@/plugins/stitch'
import router from '@/router'

const isProd = process.env.NODE_ENV === 'production'

export default function () {
  if (!isProd) { return }

  router.beforeEach((to, from, next) => {
    window.analytics.page()
    next()
  })

  const user = getCurrentUser()

  if (user) {
    window.analytics.identify(user.id,
      {
        email: user.email
      })
  }
}
